module.exports = __webpack_public_path__ + "img/mdi_format-list-group-plus.70d56e93.svg";